import { DENOMINATOR_QUERY_ALIAS } from '@modules/quantify/constants';
import { useGetQuantifyChartEQLFunctions } from '@modules/quantify/hooks/useFetchQuantifyChartData/useGetQuantifyChartEQLFunctions';
import { useGetQuantifyBaseEQLProps } from '@modules/quantify/hooks/useGetQuantifyBaseEQLProps';
import { useGetQuantifyDenominatorJoinClause } from '@modules/quantify/hooks/useGetQuantifyDenominatorJoinClause';
import { EQLProps } from 'v2/core/repository/eql/types';

export const useGetQuantifyChartEQLProps = (): Omit<
  EQLProps,
  'sourceDetailsMap'
> => {
  const baseProps = useGetQuantifyBaseEQLProps();
  const functions = useGetQuantifyChartEQLFunctions();
  const denominatorJoin = useGetQuantifyDenominatorJoinClause({
    alias: DENOMINATOR_QUERY_ALIAS,
  });

  return {
    ...baseProps,
    joins: denominatorJoin ? [denominatorJoin] : undefined,
    functions,
  };
};
